{
  "familyId": "GELD-TELLEN",
  "questions": [
    {
      "id": "GELD-TELLEN-001",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Hoeveel geld is dit in totaal?\n2 euro + 50 cent + 20 cent",
      "context": null,
      "options": ["€ 2,70", "€ 2,07", "€ 2,50", "€ 2,72"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"mode": "display", "targetCents": 270}}],
      "conceptId": "geld_tellen_euro_cent",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Tel alle bedragen op: 2 euro = 200 cent, 50 cent, 20 cent. Totaal: 200 + 50 + 20 = 270 cent = € 2,70.",
        "solutionSteps": [
          "Reken de euro's om naar centen: 2 euro = 200 cent",
          "Tel alle centen op: 200 + 50 + 20 = 270 cent",
          "Reken terug naar euro's: 270 cent = € 2,70"
        ],
        "distractorExplanations": {
          "0": "Correct! 2 euro + 50 cent + 20 cent = € 2,70.",
          "1": "Fout: je hebt de cent-bedragen niet goed opgeteld. 50 + 20 = 70 cent, niet 7 cent. Totaal: € 2,70.",
          "2": "Fout: je bent de 20 cent vergeten. 2 euro + 50 cent + 20 cent = € 2,70.",
          "3": "Fout: controleer je optelling. 50 + 20 = 70, niet 72. Totaal: € 2,70."
        }
      }
    },
    {
      "id": "GELD-TELLEN-002",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Hoeveel cent is € 1,35?",
      "context": null,
      "options": ["135 cent", "13 cent", "1.350 cent", "35 cent"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "money", "data": {"amount": 135, "label": "€ 1,35"}}],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"mode": "display", "targetCents": 135}}],
      "conceptId": "geld_euro_naar_cent",
      "variantIndex": 2,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "1 euro = 100 cent. Dus € 1,35 = 1 × 100 + 35 = 135 cent. De cijfers voor de komma zijn euro's (×100), de cijfers na de komma zijn centen.",
        "solutionSteps": [
          "Onthoud: 1 euro = 100 cent",
          "Reken de euro's om: 1 euro = 100 cent",
          "Tel de centen erbij: 100 + 35 = 135 cent"
        ],
        "distractorExplanations": {
          "0": "Correct! € 1,35 = 135 cent (1 euro = 100 cent, plus 35 cent).",
          "1": "Fout: je bent de euro vergeten. 1 euro = 100 cent, plus 35 cent = 135 cent.",
          "2": "Fout: 1 euro = 100 cent, niet 1.000 cent. € 1,35 = 135 cent.",
          "3": "Fout: je bent de euro vergeten. 1 euro = 100 cent, plus 35 cent = 135 cent totaal."
        }
      }
    },
    {
      "id": "GELD-TELLEN-003",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Welke munten heb je nodig om precies € 0,85 te betalen met zo min mogelijk munten?",
      "context": null,
      "options": [
        "1 × 50 cent + 1 × 20 cent + 1 × 10 cent + 1 × 5 cent",
        "1 × 50 cent + 1 × 30 cent + 1 × 5 cent",
        "2 × 50 cent - 15 cent",
        "17 × 5 cent"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"mode": "display", "targetCents": 85}}],
      "conceptId": "geld_munten_samenstellen",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Begin met de grootste munt die past: 50 cent. Dan 20 cent (totaal 70). Dan 10 cent (totaal 80). Dan 5 cent (totaal 85). Dat zijn 4 munten: 50 + 20 + 10 + 5 = 85 cent.",
        "solutionSteps": [
          "Begin met de grootste munt: 50 cent",
          "Nog nodig: 85 − 50 = 35 cent → 20 cent",
          "Nog nodig: 35 − 20 = 15 cent → 10 cent",
          "Nog nodig: 15 − 10 = 5 cent → 5 cent",
          "Totaal: 50 + 20 + 10 + 5 = 85 cent ✓ (4 munten)"
        ],
        "distractorExplanations": {
          "0": "Correct! 50 + 20 + 10 + 5 = 85 cent met maar 4 munten.",
          "1": "Fout: er bestaat geen munt van 30 cent. De munten zijn: 1, 2, 5, 10, 20, 50 cent en 1, 2 euro.",
          "2": "Fout: je kunt geen munten 'aftrekken'. Je telt munten bij elkaar op om een bedrag te maken.",
          "3": "Fout: 17 × 5 cent = 85 cent klopt wiskundig, maar dat zijn 17 munten! Met 50 + 20 + 10 + 5 heb je maar 4 munten nodig."
        }
      }
    },
    {
      "id": "GELD-TELLEN-004",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Hoeveel geld heeft Lena in totaal?\nZe heeft: 1 biljet van € 5, 2 munten van € 1 en 3 munten van 50 cent.",
      "context": null,
      "options": ["€ 8,50", "€ 7,50", "€ 9,00", "€ 8,00"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "money", "data": {"amount": 850, "label": "Lena's geld: € 5 + 2 × € 1 + 3 × 50c"}}],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"mode": "display", "targetCents": 850}}],
      "conceptId": "geld_tellen_combinatie",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Tel op: € 5 + 2 × € 1 + 3 × € 0,50 = € 5 + € 2 + € 1,50 = € 8,50. Stap voor stap: 5 + 2 = 7, plus 3 × 0,50 = 1,50, totaal 7 + 1,50 = € 8,50.",
        "solutionSteps": [
          "Tel het biljet: € 5",
          "Tel de euromunten: 2 × € 1 = € 2",
          "Tel de 50-centmunten: 3 × € 0,50 = € 1,50",
          "Tel alles op: € 5 + € 2 + € 1,50 = € 8,50"
        ],
        "distractorExplanations": {
          "0": "Correct! € 5 + € 2 + € 1,50 = € 8,50.",
          "1": "Fout: je bent een euro vergeten. 2 × € 1 = € 2, niet € 1. Totaal: € 5 + € 2 + € 1,50 = € 8,50.",
          "2": "Fout: 3 × 50 cent = € 1,50, niet € 2. Totaal: € 5 + € 2 + € 1,50 = € 8,50.",
          "3": "Fout: je bent de 50 cent munten vergeten. 3 × 50 cent = € 1,50. Totaal: € 5 + € 2 + € 1,50 = € 8,50."
        }
      }
    },
    {
      "id": "GELD-TELLEN-005",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Welk bedrag is het grootst?",
      "context": null,
      "options": ["€ 3,25", "€ 3,05", "€ 2,99", "€ 3,20"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "money", "data": {"amount": 325, "label": "Vergelijk de bedragen"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bedragen vergelijken",
            "content": "Vergelijk eerst de euro's (het getal vóór de komma). Als die gelijk zijn, vergelijk dan de centen (het getal ná de komma). Het grootste getal is het meest.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "geld_vergelijken",
      "variantIndex": 5,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Vergelijk de euro's eerst: € 3,25 en € 3,20 en € 3,05 zijn alle drie meer dan € 2,99. Van de drie-euro-bedragen: € 3,25 > € 3,20 > € 3,05. Dus € 3,25 is het grootst.",
        "solutionSteps": [
          "Vergelijk eerst de euro's: € 2,99 heeft 2 euro, de rest heeft 3 euro",
          "€ 2,99 valt af (minste euro's)",
          "Vergelijk de centen van de 3-euro-bedragen: 25 > 20 > 05",
          "€ 3,25 is het grootst"
        ],
        "distractorExplanations": {
          "0": "Correct! € 3,25 is het grootst: 25 cent > 20 cent > 5 cent.",
          "1": "Fout: € 3,05 heeft maar 5 cent na de komma. € 3,25 heeft 25 cent, dat is meer.",
          "2": "Fout: € 2,99 heeft maar 2 euro. De andere bedragen hebben 3 euro, dus die zijn groter.",
          "3": "Fout: € 3,20 heeft 20 cent na de komma. € 3,25 heeft 25 cent, dat is 5 cent meer."
        }
      }
    }
  ]
}